import type React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";

export const ErrorLayout = (props: React.PropsWithChildren) => {
  const { children } = props;
  const { t } = useTranslation();

  const renderFallback = () => {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div>{t("common.error.unknown.message", { defaultValue: "Что-то пошло не так" })}</div>
      </div>
    );
  };

  return (
    <ErrorBoundary
      FallbackComponent={renderFallback}
      // eslint-disable-next-line no-console
      onError={(e) => console.log("Error: ", e)}
    >
      {children}
    </ErrorBoundary>
  );
};
